export enum HeapEventName {
    afterOrderPlacementQuestionsShown = 'Checkout After Order Placement Questions Shown',
    afterOrderPlacementQuestionsSubmission = 'Checkout After Order Placement Questions Submission',
    applePayButtonView = 'ApplePay Button - View',
    beforeOrderPlacementQuestionsShown = 'Checkout Before Order Placement Questions Shown',
    beforeOrderPlacementQuestionsSubmission = 'Checkout Before Order Placement Questions Submission',
    createOrderError = 'OnCreateOrderError',
    createOrderSuccess = 'Create Order Success',
    googlePayButtonView = 'GooglePay Button - View',
    orderFailure = 'OrderFailure',
    paypalButtonClick = 'Paypal Button - Click',
    paypalButtonView = 'Paypal Button - View',
    placeOrderSuccess = 'Place Order Success',
    routerLocationChange = 'Checkout Router Location Change',
    submit = 'Checkout Submit',
    ticketSelectionPromoCodeError = 'PromoError',
    timerExpired = 'TimerExpired',
}
